import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, message } from 'antd';
import { useWriteContract } from 'wagmi';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../config/contractConfig'; 
import DashboardLayout from '../components/DashboardLayout';
import '../styles/Generate-and-Accept-InviteCode.css';

const AcceptInvite: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [projectDetails, setProjectDetails] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  // Extract query params
  const params = new URLSearchParams(location.search);
  const projectUrl = params.get('project');
  const invitationCode = params.get('code');

  const { writeContractAsync, isSuccess, isError, isPending } = useWriteContract(); 

  useEffect(() => {
    if (projectUrl && invitationCode) {
      // Fetch project details here using the invitation code
      // For now, use placeholders
      setProjectDetails({
        title: 'FigFig - Share and Earn',
        description: 'Join the project and start earning rewards!',
      });
    } else {
      // Redirect to the dashboard if query params are missing
      message.error('Invalid invite link. Redirecting to dashboard...');
      navigate('/dashboard');
    }
  }, [projectUrl, invitationCode]);

  const handleAcceptInvite = async () => {
    if (!invitationCode) {
      message.error('Invalid invitation code.');
      return;
    }

    try {
      setIsLoading(true);

      const tx = await writeContractAsync({
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'acceptInvite',
        args: [invitationCode], 
      });

      if (isPending) {
        console.log('acceptInvite pending:', isPending);
      }

      if (isError) {
        console.log('acceptInvite failed:', isError);
      }

      if (isSuccess) {
        console.log('acceptInvite generated:', isSuccess);
      }

      message.success('Invitation successfully accepted!');
      navigate('/dashboard'); // Redirect to the dashboard or appropriate page
    } catch (error: any) {
      console.error('Error accepting invite:', error);
      message.error('Failed to accept the invitation. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <div className="accept-invite-container">
        {/* Upper Half */}
        <div className="accept-invite-upper">
          <img
            src={require('../assets/images/icon.png')}
            alt="Project Icon"
            className="accept-invite-icon"
          />
          <h1 className="accept-invite-title">{projectDetails?.title || 'Loading...'}</h1>
          <p className="accept-invite-subtitle">STARFISH TECHNOLOGY - FZE</p>
          <Button
            type="primary"
            onClick={handleAcceptInvite}
            loading={isLoading}
            className="accept-invite-button"
          >
            Accept Invite
          </Button>
        </div>

        {/* Lower Half */}
        <div className="accept-invite-lower">
          <img
            src={require('../assets/images/img1.png')}
            alt="Screenshot 1"
            className="accept-invite-screenshot"
          />
          <img
            src={require('../assets/images/img2.png')}
            alt="Screenshot 2"
            className="accept-invite-screenshot"
          />
          <img
            src={require('../assets/images/img3.png')}
            alt="Screenshot 3"
            className="accept-invite-screenshot"
          />
          <img
            src={require('../assets/images/img4.png')}
            alt="Screenshot 3"
            className="accept-invite-screenshot"
          />
        </div>

        {/* Text Section */}
        <div className="accept-invite-text">
          <h2>FigFig - Share and Earn</h2>
          <p>
            Upload your videos and share them with friends to earn dollars every day!
            Share and Earn: Upload your videos and share them on social media.
            The more views your videos get, the more you earn. Easily upload, track views,
            and see your earnings grow from your content.
          </p>
          <p>
            Share other creators’ videos on your social media. Every view through your shared
            link earns you money! Monetize Your Content: Turn your creative videos into earnings
            with FigFig.
          </p>
        </div>
      </div>
  );
};

export default AcceptInvite;
